/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { IStoreSelectorViewProps } from './mfrm-store-selector';

const StoreSelectorView: React.FC<IStoreSelectorViewProps> = props => {
    const {
        BodyContainerProps,
        HeaderContainerProps,
        HeaderProps,
        ModuleProps,
        locationsMessage,
        search,
        state,
        spinner,
        locationsList,
        sociLocationsList,
        franchiseList,
        noLocationsMessage,
        // VSI Customization - starts
        banner,
        currentLocation,
        seeAllStores,
        isError,
        config: {
            enableFranchise
        }
        // terms
        // VSI Customization - ends
    } = props;
    let noLocationsMessageDisplay: boolean | undefined = false;
    if (enableFranchise) {
        noLocationsMessageDisplay = (!locationsList || isError) && (!franchiseList);
    } else {
        noLocationsMessageDisplay = (!locationsList || isError);
    }
    return (
        <Module {...ModuleProps}>
            <Node {...HeaderContainerProps}>{HeaderProps}</Node>
            <Node {...BodyContainerProps}>
                {/* VSI Customization - starts */}
                {currentLocation}
                {locationsMessage}
                {search}
                {banner}
                {_renderStoreLocations(state.isSearchInProgress, noLocationsMessageDisplay!, enableFranchise!, props.app.config.enableSociLocations, spinner, noLocationsMessage, locationsList, franchiseList)}
                {_renderSociStoreLocations(state.isSociLocationsInProgress, spinner, props.app.config.enableSociLocations, sociLocationsList, noLocationsMessage)}
                {seeAllStores}
            </Node>
        </Module>
    );
};

const _renderStoreLocations = (
    isSearchInProgress: boolean,
    noLocationsMessageDisplay: boolean,
    enableFranchise: boolean,
    enableSociLocations: boolean,
    spinner: React.ReactNode,
    noLocationsMessage: React.ReactNode,
    locationsList: React.ReactNode,
    franchiseList: React.ReactNode
): JSX.Element | undefined => {

    if (!enableSociLocations) {
        return (
            <>
                {isSearchInProgress ? spinner : <>{noLocationsMessageDisplay ? noLocationsMessage : locationsList ? locationsList : null}</>}
                {enableFranchise && franchiseList}
            </>);
    } else {
        return undefined;
    }
};

const _renderSociStoreLocations = (
    isSearchInProgress: boolean,
    spinner: React.ReactNode,
    enableSociLocations: boolean | undefined,
    sociLocationsList: any,
    noLocationsMessage: React.ReactNode
): JSX.Element | undefined => {
    if (enableSociLocations) {
        return (<>{isSearchInProgress ? spinner : sociLocationsList.props.locations.length !== 0 ? sociLocationsList : noLocationsMessage}</>);
    } else {
        return undefined;
    }
};

export default StoreSelectorView;
